import Loadable from 'react-loadable';
import { TLoader } from '../components/template';

const CreditScoreWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "credit-score-widget"*/ './credit-score').then(module => module.CreditScoreWidget),
  loading: TLoader
});

const RentReportingWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "rent-reporting-widget"*/ './rent-reporting-widget').then(
      module => module.RentReportingWidget
    ),
  loading: TLoader
});

const MyPlanWidget = Loadable({
  loader: () => import(/* webpackChunkName: "my-plan-widget"*/ './my-plan-widget').then(module => module.MyPlanWidget),
  loading: TLoader
});

const MyPlanWidgetVM = Loadable({
  loader: () => import(/* webpackChunkName: "vm-plan-widget"*/ './vm-plan-widget').then(module => module.MyPlanWidget),
  loading: TLoader
});

const MortgageWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "mortgage-widget"*/ './mortgage-widget').then(module => module.MortgageWidget),
  loading: TLoader
});

const MortgageWidgetVM = Loadable({
  loader: () =>
    import(/* webpackChunkName: "vm-mortgage-widget"*/ './vm-mortgage-widget').then(module => module.MortgageWidgetVM),
  loading: TLoader
});

const MortgageEligibilityWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "vm-mortgage-eligible-widget"*/ './vm-mortgage-helper-widget').then(
      module => module.MortgageEligibilityWidget
    ),
  loading: TLoader
});

const MortgageDIPWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "vm-mortgage-dip-widget"*/ './vm-mortgage-helper-widget').then(
      module => module.MortgageDIPWidget
    ),
  loading: TLoader
});

const PropertyGoalWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "property-goal-widget"*/ './property-goal-widget').then(
      module => module.PropertyGoalWidget
    ),
  loading: TLoader
});

const PointsWidgetVM = Loadable({
  loader: () =>
    import(/* webpackChunkName: "vm-points-widget"*/ './points-widget/vm-points').then(module => module.PointsWidgetVM),
  loading: TLoader
});

const AwardsVM = Loadable({
  loader: () =>
    import(/* webpackChunkName: "vm-points-widget"*/ './points-widget/vm-awards').then(module => module.AwardsVM),
  loading: TLoader
});

const DepositBuilderWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "deposit-builder-widget"*/ './deposit-builder-widget').then(
      module => module.DepositBuilderWidget
    ),
  loading: TLoader
});

const PensionFinderWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "pension-finder-widget"*/ './pension-finder').then(
      module => module.PensionFinderWidget
    ),
  loading: TLoader
});

const GuidanceWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ff-guidance-widget"*/ './future-fit-v2/guidance').then(
      module => module.GuidanceWidget
    ),
  loading: TLoader
});

const FlowPlaybackWidgetFF = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ff-guidance-widget"*/ './future-fit-v2/flow-playback').then(
      module => module.FlowPlaybackWidget
    ),
  loading: TLoader
});

const EligibilityWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "eligibility-widget"*/ './eligibility-widget').then(module => module.EligibilityWidget),
  loading: TLoader
});

const MABPropertyPortfolioWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "mab-property-portfolio-widget"*/ './mab-property-portfolio').then(
      module => module.MABPropertyPortfolioWidget
    ),
  loading: TLoader
});

const MABImportPortfolioWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "mab-property-portfolio-widget"*/ './mab-import-portfolio').then(
      module => module.MABImportPortfolioWidget
    ),
  loading: TLoader
});
const AffordabilityWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "affordability-result"*/ './affordability-overview').then(
      module => module.AffordabilityOverviewPage
    ),
  loading: TLoader
});
const MortgagePassportWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "mortgage-passport"*/ './mortgage-passport').then(
      module => module.MortgagePassportPage
    ),
  loading: TLoader
});
const AccordionResultWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "accordion-result-widget"*/ './accordion-result').then(
      module => module.AccordionResultWidget
    ),
  loading: TLoader
});

export const defaultWidgets = {
  'credit-score': CreditScoreWidget,
  'nz-credit-score': CreditScoreWidget,
  'rent-reporting': RentReportingWidget,
  'my-plan': MyPlanWidget,
  'vm-plan': MyPlanWidgetVM,
  mortgage: MortgageWidget,
  'what-is-within-reach': MortgageWidgetVM,
  'mortgage-eligibility': MortgageEligibilityWidget,
  'mortgage-DIP': MortgageDIPWidget,
  'deposit-builder': DepositBuilderWidget,
  'property-goal': PropertyGoalWidget,
  'vm-points': PointsWidgetVM,
  'vm-widget-award': AwardsVM,
  'partners-eligibility-check': EligibilityWidget,
  'pension-finder': PensionFinderWidget,
  'ff-guidance': GuidanceWidgetFF,
  'mab-property-portfolio': MABPropertyPortfolioWidget,
  'mab-import-portfolio': MABImportPortfolioWidget,
  'mab-affordability': AffordabilityWidget,
  'mortgage-passport': MortgagePassportWidget,
  'ff-flow-playback': FlowPlaybackWidgetFF,
  'accordion-result': AccordionResultWidget
};
